import { OnInit } from "@angular/core";
var CheckboxComponent = /** @class */ (function () {
    function CheckboxComponent() {
    }
    CheckboxComponent.prototype.ngOnInit = function () { };
    return CheckboxComponent;
}());
export { CheckboxComponent };
